import { Controller } from "@hotwired/stimulus"

// Cajón lateral de ajustes para el editor de posts (modo concentración).
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  open() { this.set(true) }
  close() { this.set(false) }
  toggle() { this.set(this.panelTarget.classList.contains("translate-x-full")) }

  set(show) {
    this.panelTarget.classList.toggle("translate-x-full", !show)
    this.backdropTarget.classList.toggle("hidden", !show)
    document.body.classList.toggle("overflow-hidden", show)
  }
}
